import React from 'react';
export function EditorPastePlainIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M17 3H4v15h2V5h11V3zm-5 8h4v2h-4v-2zm4 4h-4v2h4v-2z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 21V7h12v14H8zm2-12h8v10h-8V9z"
  }));
}